import { IconButton, TableCell, TableRow, Typography } from '@mui/material';
import React, { FC, memo } from 'react';
import { Iconify } from 'src/UIKit/Iconify';
import { useUiContext } from 'src/UIProvider';
import { ContextMenu } from 'src/UIKit/ContextMenu';
import { IMagazineCategory } from 'src/modules/magazineCategory/entity/magazineCategory/IMagazineCategory';
import { useMagazineCategoriesTableItem } from '../../../presenters/useMagazineCategoriesTableItem';

interface IProps {
    item: IMagazineCategory;
};

export const MagazineCategoriesTableRow: FC<IProps> = memo(({ item }) => {
    const { open, onOpenMenu, onCloseMenu, onDelete, onEdit } = useMagazineCategoriesTableItem(item);

    return (
        <>
            <TableRow hover>
                <TableCell component="th" scope="row" align="center" width="20%">
                    <Typography variant="subtitle2" noWrap>
                        {item.name}
                    </Typography>
                </TableCell>
                <TableCell align='center' width="70%">
                    <Typography variant="subtitle2" noWrap>{item.description}</Typography>
                </TableCell>
                <TableCell align="center" width="10%">
                    <IconButton size="large" color="inherit" onClick={onOpenMenu}>
                        <Iconify icon={'eva:more-vertical-fill'} />
                    </IconButton>
                </TableCell>
            </TableRow>
            <ContextMenu open={open} onClose={onCloseMenu} onDelete={onDelete} onEdit={onEdit} />
        </>
    );
})